<template>
    <label ref="field" :class="[{'inline': inline}, size, {'line-h': lineHeight}]" class="ui-input ui-select"> 
        <span v-if="label" class="label">
            <span v-html="label"/>
            <span v-if="required" class="label-required">*</span>
        </span>

        <div class="select-box" :class="{ design, 'disabled': disabled, 'danger': removeRequired }" >
            <select  :data-ui="dataUi" :disabled="disabled || load ? true : false" @input="handleInput" @change="handleChange" @focus="clearError">
                <option v-if="showDefault" :value="null" :selected="value === null" :hidden="!clearable && value">{{ textDefault }}</option>
                <slot/>
            </select>
            <div v-show="load" class="load-icon"/>
        </div>
    </label>
</template>

<script>
	export default {
        name: 'ui-select',
        props: {
            useTouchedValidation: {
                type: Boolean,
                default: false
            },
            shouldShowError: {
                type: Function,
                required: false,
                default() {
                    return (value, required, touched) => required && !value;
                }
            },
            dataUi: {
                type: String,
                required: false,
                default: ''
            },
            value: {
                type: null,
                required: false,
                default: null,
            },
            showDefault: {
                type: Boolean,
                required: false,
                default: true,
            },
            textDefault: {
                type: String,
                required: false,
                default: () => {
                    return 'Selecione'
                }
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            label: {
				type: String,
				required: false,
                default: ''
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            refer: {
				type: String,
				required: false,
                default: ''
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            name: {
				type: String,
				required: false,
                default: ''
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            load: {
                type: Boolean,
				required: false,
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            inline: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
            * Utilize para alterar o tamanho do input
            */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            design: {
                type: [String, Object],
                required: false,
                default: ''
            },
            /**
			 * Utilize para aplicar as classes do botão
			 */
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             * define o input como required em html5 e aplica o operador '*' na label
             */
            required: {
                type: Boolean,
                required: false,
                default: false
            },
			lineHeight: {
				type: Boolean,
				required: false,
				default: false
			},
            clearable: {
                type: Boolean,
                required: false,
                default: true
            },
		},
        data() {
            return {
                touched: false,
            }
        },
        computed: {
            removeRequired() {
                    if (this.useTouchedValidation) {
                        return this.required && !this.value && this.touched;
                    }
                    return this.required && !this.value;
                }
        },
        methods: {
			handleInput(event) {
                this.touched = true;
                this.$emit('input', event.target.value)
            },
            handleChange(event) {
                this.touched = true;
                this.$emit('change', event.target.value)
            },
            clearError(){
                this.touched = true;
                this.$refs.field.classList.remove('error')
            },
        },
    };
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>